import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);

//vue-virtual-scroller
import VueVirtualScroller from 'vue-virtual-scroller';
Vue.use(VueVirtualScroller);

// axios
import axios from "./http/axios/index.js";
Vue.prototype.$http = axios;

// Theme Configurations
import '../themeConfig.js';

// ACL
import acl from './acl/acl';

// Globally Registered Components
import './globalComponents.js';

// Styles: SCSS
import './assets/scss/main.scss';

// Tailwind
import '@/assets/css/main.css';

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Vue Router
import router from './router';

// Vuex Store
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  acl,
  data() {
    return {
      refCount: 0
    }
  },
  created () {
    let vm = this;
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      const userData = JSON.parse(userInfo);
      vm.$store.commit('setUserData', userData);
      vm.$acl.change(userData.permissions);
    }

    // axios.interceptors.request.use(function (config) {
    //     vm.$vs.loading();
    //     return config;
    // }, function (error) {
    //     vm.$vs.loading.close();
    //     return Promise.reject(error);
    // });

    // axios.interceptors.response.use(
    //   response => {
    //     vm.$vs.loading.close();
    //     return response;
    //   },
    //   error => {
    //     if (error.response.status === 401) {
    //       vm.$store.dispatch('logout');
    //     }
    //     vm.$vs.loading.close();
    //     return Promise.reject(error.response);
    //   }
    // )

    axios.interceptors.request.use((config) => {
      this.setLoading(true);
      return config;
    }, (error) => {
      this.setLoading(false);
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      this.setLoading(false);
      return response;
    }, (error) => {
      if (error.response.status === 401) {
        vm.$store.dispatch('logout');
      }
      this.setLoading(false);
      return Promise.reject(error);
    });
  },
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++;
        this.$vs.loading();
      } else if (this.refCount > 0) {
        this.refCount--;
        if(this.refCount <= 0){
          this.$vs.loading.close();
        }
      }
    }
  },
  render: h => h(App),
}).$mount('#app')
